import { MasterHelper } from 'src/app/core/utilities';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { RegulationModel } from 'src/app/core/models/regulation';
import { RegulationService } from 'src/app/core/services/regulation';
import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
//import { RegulatorStatus } from 'src/app/core/enums/regulator/regulator-status';
import { RegulationDetail } from 'src/app/core/models/regulation/regulation-detail';
import { AssessmentDialogComponent } from '../assessment-dialog/assessment-dialog.component';
import { RegulationStatusInfoModel } from 'src/app/core/models/regulation/regulation-status-info-model';
import { ChangeViewerDialogComponent } from '../../distributed-ui-components/change-viewer-dialog/change-viewer-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { RegulationStatusInfoT4Model } from 'src/app/core/models/regulation/regulation-status-infoT4-model';
import { GDPRService } from 'src/app/core/services/rulebook';
import { RegulationStatusInfoT5Model } from 'src/app/core/models/impact-assessment/impact-assessmentT5';

@Component({
  selector: 'app-current-action',
  templateUrl: './current-action.component.html',
  styleUrls: ['./current-action.component.scss']
})
export class CurrentActionComponent implements OnInit {

  @Input()
  userId!: number;
  @Input()
  itemId!: number;
  @Input()
  closedType!: string;
  @Input()
  regulationDetails!: RegulationModel;
  @Input()
  currentActions!: RegulationStatusInfoModel[];
  currentActionsT4!: RegulationStatusInfoT4Model[];
  currentActionsT5!: RegulationStatusInfoT5Model[];
  @Input()
  fromChangeViewer!:boolean;
  @Output() OnFilter = new EventEmitter<any>();
  @Output() someEvent = new EventEmitter<string>();
  toastViewModel: ToastViewModel;
  isShowToast = false;
  templateNo : number = 0;
  templateNoForAssessed:number = 0;

  constructor(private regulationService: RegulationService, public dialog: MatDialog, private gdprService: GDPRService) {
    this.toastViewModel = new ToastViewModel();
  }
  // ngOnChanges(changes: SimpleChanges): void { //Commented Out for double call is happening.
  //   this.fetchCurrentActions();
  // }

  ngOnInit(): void {
    if (!this. currentActions) {
      this.fetchCurrentActions();
    }
    // if(!this.currentActionsT4 && this.templateNo == 4){
    //   this.fetchCurrentActions();
    // }
  }

  fetchCurrentActions(): void { 
    this.gdprService.getTemplateNo().subscribe((data: any) => {
      this.templateNo = data.result;
      if(this.templateNo == 4){
        this.regulationService.getCurrentActionsT4(this.itemId).subscribe((data: RegulationStatusInfoModel[]) => {
          this.currentActions = data;
          if (this.currentActions && this.currentActions.length > 0) {
            this.OnFilter.emit(true);
          }
        });
      }
      else if(this.templateNo == 5){
        this.regulationService.getCurrentActionsT5(this.itemId).subscribe((data: RegulationStatusInfoModel[]) => {
          this.currentActions = data;
          if (this.currentActions && this.currentActions.length > 0) {
            this.OnFilter.emit(true);
          }
        });
      }
      else if(this.templateNo == 6){
        this.regulationService.getCurrentActionsT6(this.itemId).subscribe((data: RegulationStatusInfoModel[]) => {
          this.currentActions = data;
          if (this.currentActions && this.currentActions.length > 0) {
            this.OnFilter.emit(true);
          }
        });
      }
      else{
        this.regulationService.getCurrentActions(this.itemId).subscribe((data: RegulationStatusInfoModel[]) => {
          this.currentActions = data;
          if (this.currentActions && this.currentActions.length > 0) {
            this.OnFilter.emit(true); 
          }
        });
      }
    });
    
  }


  openCurrentAction(item: RegulationStatusInfoModel): void {
    if (item.closedType === 'Closed') {
      this.openEditPopup(item);
    } else {
      this.openAssessmentPopup(item.id, item.templateNo);
    }
  }

  openEditPopup(item: RegulationStatusInfoModel): void {
    let regStatus= MasterHelper.replaceAll(item.regulationStatus, '-', '');
    regStatus = MasterHelper.replaceAll(regStatus, ' ', '');
    //let regStatuskey = regStatus as keyof typeof RegulatorStatus;
    const regDetails = new RegulationDetail();
    regDetails.id = item.id;
    regDetails.regulationId = this.itemId;
    //regDetails.status  = RegulatorStatus[regStatuskey];
    regDetails.status= item.regulationStatusId;
    regDetails.comment = item.comment;
    regDetails.jurisdiction = item.jurisdiction;
    regDetails.userId = item.userId;

    regDetails.linkedIds = item.linkedIds;
    regDetails.title = this.regulationDetails.title;
    regDetails.type = this.regulationDetails.pubType;
    regDetails.filterType = 'Current Actions';
    const dialogRef = this.dialog.open(ChangeViewerDialogComponent, {
      width: '1000px',
      data: regDetails,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.updateRegulationDetail(result, this.itemId, item.userId);
      }
    });
  }

  updateRegulationDetail(regulation: RegulationDetail, id: number, userId: string): void {
    // if (!regulation.comment) {
    //   this.alertMessage('warning', 'Please enter comment');
    // } else {
      regulation.regulationId = id;
      regulation.userId = userId;
      regulation.isRead = true;
      regulation.status = +regulation.status;
      this.regulationService.updateRegulationInfo(regulation).subscribe(() => {
        this.alertMessage('success', 'Successfully updated');
      });
    //}
  }


  openAssessmentPopup(id: number, templateNo:number): void {
    
    const dialogRef = this.dialog.open(AssessmentDialogComponent, {
      width: '1800px',
      height: '870px',
      data: [id, templateNo]
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.someEvent.next();
    });
  }

  alertMessage(type: string, msg: string): void {
    if (type === 'success') {
      this.toastViewModel.Title = 'Success';
      this.toastViewModel.Type = 'success';
    } else {
      this.toastViewModel.Title = 'Warning';
      this.toastViewModel.Type = 'warning';
      this.toastViewModel.Message =
        'Impact Assessment on this Change Id already exists';
    }
    this.toastViewModel.Message = msg;
    this.isShowToast = true;
    setTimeout(() => {
      this.isShowToast = false;
    }, 3000);
  }

}
